/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_V1_Username_HeadingInputs */

const en_onboarding_v1_username_heading = /** @type {(inputs: Onboarding_V1_Username_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`First, choose a username:`)
};

const de_onboarding_v1_username_heading = /** @type {(inputs: Onboarding_V1_Username_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie zuerst einen Benutzernamen:`)
};

const pt_br2_onboarding_v1_username_heading = /** @type {(inputs: Onboarding_V1_Username_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primeiro, escolha um nome de usuário:`)
};

const tr_onboarding_v1_username_heading = /** @type {(inputs: Onboarding_V1_Username_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Önce bir kullanıcı adı seçin:`)
};

const zh_cn2_onboarding_v1_username_heading = /** @type {(inputs: Onboarding_V1_Username_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`首先，选择一个用户名：`)
};

const zh_hk2_onboarding_v1_username_heading = /** @type {(inputs: Onboarding_V1_Username_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`首先，選擇一個用戶名稱：`)
};

const ko_kr2_onboarding_v1_username_heading = /** @type {(inputs: Onboarding_V1_Username_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`먼저 사용자 이름을 선택하세요:`)
};

const ru_ru2_onboarding_v1_username_heading = /** @type {(inputs: Onboarding_V1_Username_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сначала выберите имя пользователя:`)
};

const es_419_onboarding_v1_username_heading = /** @type {(inputs: Onboarding_V1_Username_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primero, elige un nombre de usuario:`)
};

/**
* | output |
* | --- |
* | "First, choose a username:" |
*
* @param {Onboarding_V1_Username_HeadingInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const onboarding_v1_username_heading = /** @type {((inputs?: Onboarding_V1_Username_HeadingInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_V1_Username_HeadingInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_v1_username_heading(inputs)
	if (locale === "de") return de_onboarding_v1_username_heading(inputs)
	if (locale === "pt-BR") return pt_br2_onboarding_v1_username_heading(inputs)
	if (locale === "tr") return tr_onboarding_v1_username_heading(inputs)
	if (locale === "zh-CN") return zh_cn2_onboarding_v1_username_heading(inputs)
	if (locale === "zh-HK") return zh_hk2_onboarding_v1_username_heading(inputs)
	if (locale === "ko-KR") return ko_kr2_onboarding_v1_username_heading(inputs)
	if (locale === "ru-RU") return ru_ru2_onboarding_v1_username_heading(inputs)
	return es_419_onboarding_v1_username_heading(inputs)
});